import React, { createContext, useContext, useState, useEffect } from 'react';

const SidebarContext = createContext();

let globalCollapsed = null;
let listeners = [];

export function SidebarProvider({ children }) {
  const [collapsed, setCollapsed] = useState(() => {
    const saved = localStorage.getItem('sidebarCollapsed');
    return saved === 'true';
  });

  // Update global value + notify listeners
  useEffect(() => {
    globalCollapsed = collapsed;
    localStorage.setItem('sidebarCollapsed', collapsed);
    listeners.forEach(fn => fn(collapsed));
  }, [collapsed]);

  const toggleSidebar = () => setCollapsed(prev => !prev);

  return (
    <SidebarContext.Provider value={{ collapsed, toggleSidebar }}>
      {children}
    </SidebarContext.Provider>
  );
}

export function useSidebar() {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
}

// ✅ NEW: Hook that syncs to the global context and updates reactively
export function usePersistentCollapsedState() {
  const [value, setValue] = useState(() => {
    const saved = localStorage.getItem('sidebarCollapsed');
    return saved === 'true';
  });

  useEffect(() => {
    // Sync initial global value
    if (globalCollapsed !== null) {
      setValue(globalCollapsed);
    }

    // Subscribe to updates
    const updateFn = (val) => setValue(val);
    listeners.push(updateFn);

    return () => {
      listeners = listeners.filter(fn => fn !== updateFn);
    };
  }, []);

  return value;
}
